module.exports = __webpack_public_path__ + "static/globo-logo-5201de1fce90cdbceff19d4d5dec2db2.png";